import {initSliders} from '$c3base/swiper.js';
import {initTabs} from '$c3base/tabs.js';
import {initBannerBackgroundImageContainer, bannerBackgroundImageContainer} from '$c3base/banner-background.js';
import {initMobileNav} from '$c3base/check-mobile-nav.js';

initMobileNav();
initBannerBackgroundImageContainer();
initSliders().catch(console.log);
initTabs();

import('$c3base/photoswipe.js')
    .then(({init}) => init());

$(window).on('resize', function (e) {
    if (bannerBackgroundImageContainer) {
        initBannerBackgroundImageContainer();
    }
});
